export class UserRequestCategoryDto {
    userRequestCategoryId: number;
    userId: number;
    requestCategoryId: number;
}